import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { EN_T } from "./translations/en";
import { FR_T } from "./translations/fr";

const resources = {
  en: {
    translation: EN_T,
  },
  fr: {
    translation: FR_T,
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "fr",
    interpolation: {
      escapeValue: false,
    }
  });

  export default i18n;